import React, { ReactElement } from "react";
import ClickAwayListener from "react-click-away-listener";
import { getCypressTestId } from "../../utils/config";

interface Item {
  id: string;
}

interface Props {
  item?: Item | null;
  id: string;
  onClickAway: () => void;
  children: ReactElement;
}

const MyClickAwayListener: React.FC<Props> = ({
  onClickAway,
  children,
  id,
  item,
}) => {
  return (
    <div id={id} data-cy={id} data-testid={getCypressTestId(item)}>
      <ClickAwayListener onClickAway={onClickAway}>
        {children}
      </ClickAwayListener>
    </div>
  );
};

export default MyClickAwayListener;
